<template>

  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-address-form"
                ref="filter_dropdown_requests"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <request-filters
                  :status-filter.sync="statusFilter"
                  :status-options="statusOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refTransferOwnershipListTable"
        class="position-relative min-height-150"
        :items="fetchTransferOwnershipLists"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'TransferOwnership')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'app-customer-transfer-ownership-view', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>
        <template #cell(fileNo)="data">
          <div class="text-nowrap">
            File no.: <b-button
              v-if="canViewThisAction('show', 'File')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'customers-files-show', params: { id: data.item.fileID } }"
            >
              {{ data.item.fileNo }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.fileNo }}
            </b-button>
            <br>
            <span
              class=""
            >
              {{ data.item.nvsFileType }} ({{ data.item.lotLocation }})
            </span>
            <br>
            <span
              class=""
            >
              {{ data.item.originalAgent && data.item.originalAgent.name }} ({{ data.item.originalAgent && data.item.originalAgent.code }})
            </span>
          </div>
        </template>
        <template #cell(transferor)="data">
          <div class="">
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased no-padding-table"
            >
              <b-tbody>
                <b-tr>
                  <b-td class="width-50">
                    <b-avatar
                      text="P"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    <b-button
                      v-if="canViewThisAction('show', 'Customer')"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="weight-600 align-middle detail-view-id"
                      :to="{ name: 'customers-customers-show', params: { id: data.item.originalPurchaser ? data.item.originalPurchaser.customer : '0' } }"
                    >
                      {{ data.item.originalPurchaser && data.item.originalPurchaser.name }}
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="none"
                      class="text-bold-black align-middle detail-view-id not-button"
                    >
                      {{ data.item.originalPurchaser && data.item.originalPurchaser.name }}
                    </b-button>
                  </b-td>
                  <td />
                </b-tr>
                <b-tr>
                  <b-td class="width-50">
                    <b-avatar
                      text="E"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    {{ data.item.originalPurchaser && data.item.originalPurchaser.email }}
                  </b-td>
                  <td class="width-50">
                    <feather-icon
                      icon="ArrowRightIcon"
                      size="18"
                      class="align-middle text-body"
                    />
                  </td>
                </b-tr>
                <b-tr>
                  <b-td class="width-50">
                    <b-avatar
                      text="M"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    {{ data.item.originalPurchaser && data.item.originalPurchaser.contact }}
                  </b-td>
                  <td />
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </template>

        <template #cell(transferee)="data">
          <div class="">
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased no-padding-table"
            >
              <b-tbody>
                <b-tr>
                  <b-td class="width-50">
                    <b-avatar
                      text="P"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    {{ data.item.newPurchaser && data.item.newPurchaser.name }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td class="width-50">
                    <b-avatar
                      text="E"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    {{ data.item.newPurchaser && data.item.newPurchaser.email }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td class="width-50">
                    <b-avatar
                      text="M"
                      variant="light-primary"
                    />
                  </b-td>
                  <b-td style="width: 300px;">
                    {{ data.item.newPurchaser && data.item.newPurchaser.contact }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(currentStatus)="data">
          <b-badge
            :variant="`light-${resolveLogStatusVariant(data.item.currentStatus)}`"
            style="font-size: 14px; font-weight: 400;"
          >
            <span class="text-capitalize">{{ data.item.currentStatus }}</span>
          </b-badge>
          <template v-if="['Approved', 'Rejected by NV', 'Withdrawn by OP', 'Withdrawn by NP'].includes(data.item.currentStatus)">
            <br>
            <span
              v-if="['Approved', 'Rejected by NV'].includes(data.item.currentStatus)"
              class="mt-25 d-block text-muted-999"
            >
              {{ data.item.adminActionDate ? dateFormat(data.item.adminActionDate) : '-' }}
            </span>
            <span
              v-else-if="data.item.currentStatus == 'Withdrawn by OP'"
              class="mt-25 d-block text-muted-999"
            >
              {{ data.item.opWithdrawDate ? dateFormat(data.item.opWithdrawDate) : '-' }}
            </span>
            <span
              v-else-if="data.item.currentStatus == 'Withdrawn by NP'"
              class="mt-25 d-block text-muted-999"
            >
              {{ data.item.npActionDate ? dateFormat(data.item.npActionDate) : '-' }}
            </span>
          </template>
          <template v-if="['Approved', 'Rejected by NV', 'Withdrawn by OP'].includes(data.item.currentStatus) && data.item.internalRemarks">
            <span class="mt-25 text-muted-999">
              "{{ data.item.internalRemarks }}"
            </span>
          </template>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'TransferOwnership') || canViewThisAction('approve', 'TransferOwnership') || canViewThisAction('reject', 'TransferOwnership') || canViewThisAction('withdraw-op', 'TransferOwnership')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'TransferOwnership')"
              :to="{ name: 'app-customer-transfer-ownership-view', params: { id: data.item._id } }"
            >
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('approve', 'TransferOwnership') && data.item.currentStatus == 'Awaiting Approval'"
              @click="approveRequest(data.item)"
            >
              <span class="align-middle ml-50">Approve</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('reject', 'TransferOwnership') && data.item.currentStatus == 'Awaiting Approval'"
              @click="rejectRequest(data.item)"
            >
              <span class="align-middle ml-50">Reject</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewThisAction('withdraw-op', 'TransferOwnership') && (data.item.currentStatus == 'Awaiting Approval' || data.item.currentStatus == 'Pending NP')"
              @click="withdrawRequest(data.item)"
            >
              <span class="align-middle ml-50">Withdraw by OP</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>

    <div
      v-if="totalRequests > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRequests"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend, BButton, BAvatar,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormTag, BTableSimple, BTbody, BTr, BTd,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import useTransferOwnershipList from './requestList'
import requestStoreModule from './requestStoreModule'
import RequestFilters from './RequestFilters.vue'
import ToastificationContentCustom from '../../../operation/ToastificationContentCustom.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BButton,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BAvatar,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    RequestFilters,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      user: store.state.auth.userData,
      internalRemarks: '',
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_requests.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_requests.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.statusFilter = []
    },
    approveRequest(request) {
      this.internalRemarks = request.internalRemarks
      const titleText = 'Transfer of Ownership Request'
      this.$swal({
        title: `Approve this ${titleText}?`,
        html: `
    <p class="mb-1">You are going to approve this ${titleText}. Are you sure?</p>
    <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px;">
    <label for="remarks-ta" style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">
      Internal Remarks
    </label>
    <textarea id="remarks-ta" class="swal2-textarea reject-note-ta" placeholder="Enter remarks" style="margin: 0; width: 100%;"></textarea></div>
  `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/success.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const textarea = document.getElementById('remarks-ta')
          const inputValue = textarea.value
          const errorContainer = document.getElementById('swal-approve-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-approve-error'
              errorEl.style.cssText = 'display: block; color: #d91b35; text-align: left; padding: 4px 20px 0;'
              errorEl.innerText = 'Remarks are required to approve the request.'
              textarea.parentNode.insertAdjacentElement('afterend', errorEl)
            }
            return false
          }

          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
      })
        .then(result => {
          if (result.value) {
            this.internalRemarks = result.value
            this.updateChange('approved', request)
          }
        })
    },
    rejectRequest(request) {
      this.internalRemarks = request.internalRemarks
      this.$swal({
        title: 'Are you sure you want to reject this request?',
        html: `
    <p class="mb-1">Once you reject this request <strong>${request.stringID},</strong><br>customer will be informed.</p>
    <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px;">
    <label for="remarks-ta-reject" style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">
      Internal Remarks
    </label>
    <textarea id="remarks-ta-reject" class="swal2-textarea reject-note-ta" placeholder="Enter remarks" style="margin: 0; width: 100%;"></textarea></div>
  `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/file-cross.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, reject request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const textarea = document.getElementById('remarks-ta-reject')
          const inputValue = textarea.value
          const errorContainer = document.getElementById('swal-reject-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-reject-error'
              errorEl.style.cssText = 'display: block; color: #d91b35; text-align: left; padding: 4px 20px 0;'
              errorEl.innerText = 'Remarks are required to reject the request.'
              textarea.parentNode.insertAdjacentElement('afterend', errorEl)
            }
            return false
          }

          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
      })
        .then(result => {
          if (result.value) {
            this.internalRemarks = result.value
            this.updateChange('rejected', request)
          }
        })
    },
    withdrawRequest(request) {
      this.internalRemarks = request.internalRemarks
      this.$swal({
        title: 'Are you sure you want to withdraw this request on behalf of the original purchaser?',
        html: `
    <p class="mb-1">Once you withdraw this request <strong>${request.stringID},</strong><br>customer will be informed.</p>
    <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px;">
    <label for="remarks-ta-withdraw" style="font-weight: 500; font-size: 14px; margin-bottom: 4px;">
      Internal Remarks
    </label>
    <textarea id="remarks-ta-withdraw" class="swal2-textarea reject-note-ta" placeholder="Enter remarks" style="margin: 0; width: 100%;"></textarea></div>
  `,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/rotate.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, withdraw request',
        cancelButtonText: 'No, go back',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
        preConfirm: () => {
          const textarea = document.getElementById('remarks-ta-withdraw')
          const inputValue = textarea.value
          const errorContainer = document.getElementById('swal-withdraw-error')

          if (!inputValue || inputValue.trim() === '') {
            textarea.classList.add('swal-input-error')
            if (!errorContainer) {
              const errorEl = document.createElement('small')
              errorEl.id = 'swal-withdraw-error'
              errorEl.style.cssText = 'display: block; color: #d91b35; text-align: left; padding: 4px 20px 0;'
              errorEl.innerText = 'Remarks are required to withdraw the request.'
              textarea.parentNode.insertAdjacentElement('afterend', errorEl)
            }
            return false
          }

          textarea.classList.remove('swal-input-error')
          if (errorContainer) errorContainer.remove()

          return inputValue
        },
      })
        .then(result => {
          if (result.value) {
            this.internalRemarks = result.value
            this.updateChange('withdrawn', request)
          }
        })
    },
    updateChange(status, request) {
      const titleText = 'Transfer of Ownership Request'
      let title = ''
      let postUrl = ''
      let toastContent = ''
      let toastIcon = ''
      let toastVariant = ''
      let customIcon = null
      if (status === 'approved') {
        title = `You've approved ${request.stringID}`
        toastContent = `${request.newPurchaser.name} has been approved as the new purchaser for File No. <strong>${request.fileNo} – ${request.nvsFileType} (${request.lotLocation}).</strong>`
        toastIcon = 'CheckCircleIcon'
        toastVariant = 'success'
        postUrl = `customer/file-transfer/${request._id}/approve`
      } else if (status === 'rejected') {
        title = `You've rejected ${request.stringID}`
        toastContent = `The ${titleText} for File No. <strong>${request.fileNo} – ${request.nvsFileType} (${request.lotLocation})</strong> has been rejected.`
        toastIcon = 'FileMinusIcon'
        // eslint-disable-next-line global-require
        customIcon = require('@/assets/images/icons/file-cross.png')
        toastVariant = 'danger'
        postUrl = `customer/file-transfer/${request._id}/reject`
      } else if (status === 'withdrawn') {
        title = `You've withdrawn ${request.stringID}`
        toastContent = `The ${titleText} for File No. <strong>${request.fileNo} – ${request.nvsFileType} (${request.lotLocation})</strong> has been withdrawn by OP.`
        toastIcon = 'RotateCcwIcon'
        toastVariant = 'info'
        postUrl = `customer/file-transfer/${request._id}/withdraw`
      }
      const formData = new FormData()
      formData.append('status', status)
      formData.append('internalRemarks', this.internalRemarks)

      this.$http.post(postUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.refetchData()
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title,
                text: toastContent,
                icon: toastIcon,
                customIcon,
                variant: toastVariant,
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const TO_LIST_APP_STORE_MODULE_NAME = 'app-transfer-ownership-list'

    // Register module
    if (!store.hasModule(TO_LIST_APP_STORE_MODULE_NAME)) store.registerModule(TO_LIST_APP_STORE_MODULE_NAME, requestStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TO_LIST_APP_STORE_MODULE_NAME)) store.unregisterModule(TO_LIST_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Pending NP', value: 'Pending NP' },
      { label: 'Withdrawn by NP', value: 'Withdrawn by NP' },
      { label: 'Withdrawn by OP', value: 'Withdrawn by OP' },
      { label: 'Approved', value: 'Approved' },
      { label: 'Rejected by NV', value: 'Rejected by NV' },
      { label: 'Awaiting Approval', value: 'Awaiting Approval' },
      { label: 'Expired', value: 'Expired' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchTransferOwnershipLists,
      tableColumns,
      perPage,
      currentPage,
      totalRequests,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      requestData,
      isSortDirDesc,
      refTransferOwnershipListTable,
      refetchData,

      toDeletedID,
      currentDataLength,
      statusFilter,
      fileStatusFilter,
      fileTypeFilter,

      // UI
      resolveLogStatusVariant,
    } = useTransferOwnershipList()

    return {

      // Sidebar

      fetchTransferOwnershipLists,
      tableColumns,
      perPage,
      currentPage,
      totalRequests,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTransferOwnershipListTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      currentDataLength,
      requestData,

      // Filter
      avatarText,
      canViewThisAction,
      statusFilter,
      fileStatusFilter,
      fileTypeFilter,

      // UI
      resolveLogStatusVariant,

      statusOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
